var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTravelinvoices(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 55 30",
    style: {
      enableBackground: "new 0 0 30 30"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;}\n\t.st1{fill:#465867;}\n\t.st2{fill:#FF7300;}\n\t.st3{fill:#E8E8E8;stroke:#465867;stroke-width:1.25;stroke-miterlimit:5;}\n\t.st4{fill:none;stroke:#465867;stroke-width:0.625;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:5;}\n\t.st5{fill:#FFF0E1;stroke:#FF7300;stroke-width:1.25;stroke-linejoin:round;stroke-miterlimit:5;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    width: 30,
    height: 30
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M0,2.2V15h15V0H2.5C1.1,0,0,1,0,2.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M15,15v15H2.5C1.1,30,0,29,0,27.8V15H15z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M8.8,4.7h13.4c1,0,1.9,0.8,1.9,1.9v17.3c0,1-0.8,1.9-1.9,1.9H8.8c-1,0-1.9-0.8-1.9-1.9V6.6 C6.9,5.6,7.7,4.7,8.8,4.7z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 9.5,
    y1: 12.5,
    x2: 21.2,
    y2: 12.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M18.3,17.9l0-2.2c0.6,0.1,0.9,0.2,1.7,0.5l0.4-0.9c-0.9-0.4-1.4-0.6-2.1-0.7v-1h-0.7v1c-3,0.1-3.4,3.9,0,4.2 v2.3c-0.7,0.1-1.7-0.4-2.2-0.8L15,21.1c0.6,0.6,1.7,1,2.6,1v1.2h0.7v-1.2C21.4,21.9,22.1,18.1,18.3,17.9z M17.6,15.7v2.1 C15.5,17.3,16.3,15.7,17.6,15.7z M18.3,21.1v-2.2C20.3,18.9,20.4,20.9,18.3,21.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M28.7,4.5c0.1,0.9-0.5,1.7-1.4,1.9c-1,0.3-2.1,0.6-3.3,0.9c-0.5,0.9-1,1.7-1.3,2.4c-0.3,0.6-1.1,0.9-1.7,0.8 c-0.8-0.1-1.2-0.7-1.1-1.4c0.1-0.3,0.1-0.6,0.2-1c-1.2,0.3-2.4,0.5-3.2,0.7c-0.7,0.2-1.4-0.3-1.6-0.9V7.8c-0.3-0.9-0.5-2-0.7-2.9 c-0.1-0.7,0.3-1.4,1-1.6c0.7-0.2,1.4,0,1.7,0.6c0.2,0.4,0.5,0.9,0.7,1.5c1.9-0.8,4.6-1.9,6.9-2.7C26.6,2.1,28.5,2.8,28.7,4.5z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 12.3,
    y1: 10.5,
    x2: 12.3,
    y2: 22.3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTravelinvoices);
export default __webpack_public_path__ + "static/media/travelinvoices.4ef96aef819a3aff2b9be06f1917346e.svg";
export { ForwardRef as ReactComponent };